var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.375V36.6562V41.1333C0 46.5825 4.41745 51 9.86666 51H43.6442C45.5951 51 47.4661 50.3284 48.8455 49.1328C50.225 47.9373 51 46.3158 51 44.625V11.3333H47.3221H41.8222C40.0058 11.3333 38.5333 9.86085 38.5333 8.04445V0H7.35577C5.4049 0 3.53394 0.671654 2.15446 1.8672C0.774986 3.06274 0 4.68425 0 6.375Z",
    fill: "#868EAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListening);
export default __webpack_public_path__ + "static/media/listening.22b3271935c10fc9b4cff6126a835e93.svg";
export { ForwardRef as ReactComponent };